import React from 'react';

import {ScoresListHeaderModuleMobileDaterButton} from "./scores-list-header-module.mobile-dater-button";
import {ScoresListHeaderModuleMobileDatePicker} from "./scores-list-header-module.mobile-date-picker";
import {ScoresListHeaderModuleProps} from "../../models/scores-list-header-module.props";
import {ScoresListHeaderModuleMobileDateViewModel} from "../../models/scores-list-header-module.mobile-date.view-model";
import {observer} from "mobx-react";
import {SCORES_HEADER_MODULE} from "../../scores-list-header-module.consts"

export class ScoresListWidgetHeaderMobileDaterComponentProps extends ScoresListHeaderModuleProps {
}

export const ScoresListHeaderModuleMobileDater = observer(({controller, onDateChange}: ScoresListWidgetHeaderMobileDaterComponentProps) => {
  const {state, device} = controller;

  const translateXWidth =
    state.mobileDateWidth *
    state.daysOffset * (
      device.isRtl ? 1 : -1);

  const datePickerProps = {
    controller,
    id: 'calender-button',
    selectedDate:
    state.startDate,
    linkType:
    state.linkType,
    onDateChange: onDateChange
  };

  const dateSelectorProps = {
    className: 'scores-list-header-module-mobile-dater-date-selector-container',
    style: {
      width:
      state.mobileDateWidth,
    }
  }

  const mobileDaysProps = {
    className: 'scores-list-header-module-mobile-days',
    style: {
      width:
        state.mobileDateWidth *
        state.visibleMobileDates,
    }
  }

  const innerMobileDaysProps = {
    id: 'mobile-dater',
    className: 'scores-list-header-module-inner-mobile-days',
    style: {
      transform: `translateX(${translateXWidth}px)`,
      transition: `transform ${SCORES_HEADER_MODULE.ANIMATION_DURATION}ms linear`
    }
  }

  return (
    <div className={'scores-list-header-module-mobile-dater-container'}>
      <div {...mobileDaysProps}>
        <div {...innerMobileDaysProps}>
          {
            state.mobileCurrentDays.map((dayObject: ScoresListHeaderModuleMobileDateViewModel, i) =>
              <ScoresListHeaderModuleMobileDaterButton
                controller={controller}
                mobileDate={dayObject}
                isActive={state.startDate.toDateString() === dayObject.date.toDateString()}
                width={state.mobileDateWidth} key={i}
                onDateChange={onDateChange}
              />)
          }
        </div>
      </div>
      <div {...dateSelectorProps}>
        <ScoresListHeaderModuleMobileDatePicker {...datePickerProps} />
      </div>
    </div>
  );
});
